/* global flatpickr, rangePlugin */
const loadEventFlatpickr = {
	el: {
		inputCheckIn: document.querySelector('.js-form-check-in'),
		inputCheckOut: document.querySelector('.js-form-check-out'),
		flatPickerContainer: document.querySelectorAll('.js-form-flatpickr')
	},

	fxInitFlatpickr(el) {
		// save in a variable options of flatpickr
		const flatpickrOptions = {
			locale: el.dataset.language,
			// single mode is default
			mode: 'single',
			// minDate is the minimum date that can be selected
			minDate: 'today',
			dateFormat: 'Y-m-d',
			//allow input is for make sure validation works when nothing is selected
			allowInput: true,
			disableMobile: 'true',
			plugins: [new rangePlugin({ input: this.el.inputCheckOut })]
		}

		flatpickr(el, flatpickrOptions)
	},

	events() {

		// Responsible for datepicker on Check in and Check out input
		this.el.flatPickerContainer.forEach(el => this.fxInitFlatpickr(el))
	},

	init() {
		this.events()
	}
}

loadEventFlatpickr.init()
